import PropType from "prop-types";

import styled from "styled-components/macro";
import FnrFade from "UI/FnrFade/FnrFade";

import { useGetCTAs } from "../API/queries";

import CTA from "./CTA";

export default function CTAs({ fundID, showing = false 
}) {
  const { data: { callToActions = [] } = {}, isLoading} = useGetCTAs({
    fundID,
    enabled: !!fundID && showing,
  });

  return (
    <FnrFade show={Boolean(callToActions.length) && !isLoading}>
    <Wrapper data-cy="CTA_Container">
      {callToActions.map((cta) => (
        <CTA key={cta.ID} {...cta} />
      ))}
    </Wrapper>
    </FnrFade>
  );
}

CTAs.propTypes = {
  fundID: PropType.number.isRequired,
  showing: PropType.bool,
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;
